export function favorite(){
    document.addEventListener('click', (e) => {
        let element = e.target;

        if(element && element.classList.contains('favorite_fag')) {

            let formData = new FormData();
            formData.append('action', 'set_favorite');
            formData.append('_wpnonce', ajax_object.wp_nonce);
            formData.append('fag_id', element.dataset.fagId)

            let request = new XMLHttpRequest(),
                method = 'POST',
                url = ajax_object.ajax_url;

            request.open(method, url, true);
            request.send(formData)

            request.onerror = function () {
                console.log('ERROR: ' + this.response)
            }

            request.onload = function () {
                let response = JSON.parse(this.response).data;

                if (response.action == 'add') {
                    element.classList.add('selected', 'btn-star-fill')
                    element.classList.remove('btn-star')

                    element.setAttribute('aria-checked', 'true');
                }

                if (response.action == 'remove') {
                    element.classList.remove('selected', 'btn-star-fill')
                    element.classList.add('btn-star')
                    element.setAttribute('aria-checked', 'false');

                    if(document.body.classList.contains('page-template-temp-favorites')){
                        element.closest('.cards__item').remove();
                        is_container_empty();
                    }
                }
            }
        }
    })
}

function is_container_empty(){
    let card_container = document.querySelector('.cards__container:first-of-type')

    if(card_container.querySelector('.cards__item') === null){
        card_container.innerHTML = `<div class="no-results">
                            <p>Der er ingen gemte fag.<br ><br >
                                <a class="button btn-background btn-icon btn-arrow btn-animated btn-secondary" href="${window.location.protocol}//${window.location.host}/fag">Gå til fagmoduloversigt</a></p>
                        </div>`
    }
}